<template>
  <Top>
    <div class="edit">
      <div class="content">
        <!-- 输入 -->
        <div>
          <van-field
            v-model="groupInfo.name"
            maxlength="15"
            autofocus
            ref="input"
            show-word-limit
            label="名称"
            placeholder="请输入分组名"
          />

          <!-- 执行时长 -->
          <div>
            <van-cell
              is-link
              title="执行时长"
              @click="ishow = true"
              :value="actionTime"
            ></van-cell>
          </div>
        </div>

        <!-- 阀门列表 -->
        <div class="fm-list fs28">
          <div class="fm-item">
            <van-checkbox-group v-model="checkList">
              <div v-if="fmList && fmList.length">
                <div class="title">网关阀门</div>
                <van-checkbox
                  class="check-item"
                  v-for="item in fmList"
                  :key="item.id"
                  :name="`fm_${item.id}`"
                >
                  {{ item.portName }}
                </van-checkbox>
              </div>
              <div v-if="rtuList && rtuList.length">
                <div class="title title2">RTU阀门</div>
                <van-checkbox
                  class="check-item"
                  v-for="item in rtuList"
                  :key="item.id"
                  :name="`rtu_${item.id}`"
                >
                  {{ item.portName }}
                </van-checkbox>
              </div>
            </van-checkbox-group>
          </div>
        </div>

        <van-popup
          v-model="ishow"
          position="bottom"
          :style="{ height: '40%' }"
          @click-overlay="onCancel"
        >
          <van-datetime-picker
            title="时 分"
            type="time"
            :confirm-button-text="$t('member.login_out_ok')"
            :cancel-button-text="$t('member.login_out_cancel')"
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
          />
        </van-popup>
      </div>
      <!-- 底部按钮 -->
      <div class="footer">
        <span class="cancel" @click="handleCancel">取消</span>
        <span class="add" @click="handleComfirm">确定</span>
      </div>
    </div>
  </Top>
</template>

<script>
import Top from './../../top.vue'
export default {
  components: {
    Top,
  },
  data() {
    function timeRange(num) {
      const _arr = []
      for (let i = 0; i < num; i++) {
        _arr.push(i.toString().padStart(2, '0'))
      }
      return _arr
    }

    return {
      groupInfo: {},
      type: '',
      rtuList: [],
      fmList: [],
      checkList: [],
      list: [],
      canSubmit: true,
      ishow: false,
      actionTime: '', // 执行时长
      columns: [
        {
          values: timeRange(12),
          defaultIndex: 1,
        },
        {
          values: timeRange(60),
          defaultIndex: 2,
        },
        {
          values: timeRange(60),
          defaultIndex: 3,
        },
      ],
    }
  },

  async mounted() {
    const { type } = this.$route.query

    let deviceType = sessionStorage.getItem('deviceType')
    if (deviceType != null) {
      deviceType = Number(deviceType)
    }

    let no = localStorage.getItem('no')
    // 判断如果是网关阀门 只请求网关阀门的 是RTU的 则需要请求RTU和网关阀门的

    this.$toast({
      type: 'loading',
      message: '阀门加载中...',
      forbidClick: true,
      duration: 0,
    })

    let fmList = await this.getFMList(no)
    let d = await this.getRtuList(no)
    // 请求RTU阀门列表
    let rtuList = []
    if (deviceType === 6) {
      rtuList = await this.getRTUInfo(d)
    }
    console.log('rtuList:', rtuList, fmList)

    this.rtuList = rtuList && rtuList.length ? [...rtuList] : []
    this.fmList = fmList && fmList.length ? [...fmList] : []
    this.list = [].concat(fmList).concat(rtuList)
    this.$toast.clear()

    this.type = type
    if (type === 'add') {
      this.groupInfo = {
        name: '',
      }
    } else {
      // 编辑
      let data = JSON.parse(sessionStorage.getItem('currentGroupInfo'))
      this.groupInfo = { name: data.name, id: data.id }

      console.log('data:', data)

      let list = data.list
      const prefix = ['fm', 'rtu']
      // 遍历 rtu fm 列表 根据id匹配 看是fm 的还是 rtu 加上前缀
      prefix.map((fix) => {
        if (this[`${fix}List`] && this[`${fix}List`].length) {
          list.map((item) => {
            const target = this[`${fix}List`].find((o) => o.id === item.id)
            if (target) {
              this.checkList.push(`${fix}_${item.id}`)
            }
          })
        }
      })

      // 执行时长  多少秒 膜 60 剩下的是具体的秒

      const second = data.second
      let hour = 0,
        min = 0,
        sec = 0
      let oneHour = 60 * 60
      if (second >= oneHour) {
        console.log(1)
        hour = Math.floor(second / oneHour)
      }

      min = Math.floor((second - hour * oneHour) / 60)

      sec = (second - hour * oneHour - min * 60) % 60

      console.log(hour, min, sec)

      hour = String(hour).padStart(2, '0')
      min = String(min).padStart(2, '0')
      sec = String(sec).padStart(2, '0')

      this.actionTime = `${hour}:${min}:${sec}`
    }
  },

  methods: {
    // 获取网关阀门列表
    async getFMList(no) {
      return await this.$api
        .getValaveList({ gatewayNo: no })
        .then(async (res) => {
          const data = res.list
          if (res.errcode === 0 && data && data.length) {
            return data.map((item) =>
              Object.assign(item, { type: 'fm', portName: item.name }),
            )
          }

          return []
        })
        .catch((err) => {
          return []
        })
    },

    // 获取阀门列表
    getRtuList(no) {
      return this.$api
        .getRtuList({
          gatewayNo: no,
        })
        .then((res) => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.data)) {
              return [...res.data]
            } else {
              return []
            }
          } else {
            this.$toast(res.errmsg)
            return []
          }
        })
    },

    // 阀门信息
    async getRTUInfo(rtuList) {
      if (!rtuList || !rtuList.length) return []
      let portsList = []
      await rtuList.map(async (item, index) => {
        if (item.valves && item.valves.length) {
          item.valves.map((_item) => {
            _item = {
              ..._item,
              rtuNo: item.no,
              systemTimestamp: item.systemTimestamp,
              nameFirst: _item.portName[0],
              nameSecod: _item.portName.match(/\d{1,}/g)[0],
              type: 'rtu',
            }
            portsList.push(_item)
          })
        }
      })

      const list = [...this.sortRTU(portsList)]
      return list
    },

    sortRTU(rtuList) {
      const data = [...rtuList]
      let reg = /\d{1,}/g
      let names = []
      let group = new Set()
      // 先分组
      let groupTrunk = []

      if (data && data.length) {
        data.map((item) => {
          group.add(item.nameFirst)
        })
        group = Array.from(group).sort()
        group.map((groupId) => {
          let arr = []
          data.map((item) => {
            if (groupId === item.nameFirst) {
              arr.push(item)
            }
          })
          groupTrunk = groupTrunk.concat(this.sortGroup(arr))
        })
      }

      groupTrunk.map((item) => {
        names.push(item.portName)
      })

      return groupTrunk
    },

    sortGroup(data) {
      // 第二排序条件
      return data.sort((a, b) => {
        let _a = Number(a.nameSecod)
        let _b = Number(b.nameSecod)
        return _a - _b
      })
    },

    // 取消时间弹窗
    onCancel() {
      this.ishow = false
    },

    // 选择时长
    onConfirm(v) {
      // this.$set(this.groupList[this.fmListIndex], "timeLong", v + ":00");
      this.actionTime = v + ':00'
      this.onCancel()
    },

    // 取消
    handleCancel() {
      this.$router.back()
    },

    // 确定
    handleComfirm() {
      if (!this.groupInfo.name) {
        return this.$toast.fail('分组名称不能为空')
      }

      if (!this.actionTime) return this.$toast.fail('请设置执行时长')

      if (this.checkList && !this.checkList.length) {
        return this.$toast.fail('请选择阀门')
      }

      if (this.canSubmit) {
        this.submit()
      }
    },

    // 提交
    submit() {
      this.canSubmit = false
      // type: 分组类型, //1-网关阀门，2-rtu 阀门
      // id: “阀门 ID”,
      // switch: “开关” //1-开，2-关
      // gatewayNo: “网关 ID”,//type=1 时必传
      // no: “rtu 编号”// type=2 时必传
      const list = [...this.checkList]
      const checkVolList = []
      const prefix = ['fm', 'rtu']

      const arr = this.actionTime.split(':').filter((o) => o)
      arr.pop()

      // 分组中网关阀门和RTU阀门不能共存
      // 不修改以前的逻辑
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        for (let j = 0; j < prefix.length; j++) {
          const _item = prefix[j]
          if (item.indexOf(_item) > -1) {
            let id = item.split(`${_item}_`)
            id = id.filter((o) => o)[0]
            const target = this[`${_item}List`].find(
              (o) => o.id.toString() === id,
            )
            const obj = {
              id: target.id,
              switch: 2,
              type: 1,
            }

            if (_item === 'fm') {
              obj.gatewayNo = localStorage.getItem('no')
              obj.type = 1
            } else {
              obj.no = target.rtuNo
              obj.type = 2
            }
            checkVolList.push(obj)
            break
          }
        }
      }

      let set = new Set()

      checkVolList.map((item) => {
        set.add(item.type)
      })

      if (set.size > 1) {
        this.canSubmit = true
        return this.$toast('分组中不能同时存在两种不同类型的阀门')
      }

      const min = Number(arr[0]) * 60 * 60
      const sec = Number(arr[1]) * 60

      let second = min + sec

      this.$api
        .addGroup({
          name: this.groupInfo.name,
          id: this.type === 'edit' ? this.groupInfo.id : null,
          list: [...checkVolList],
          gatewayNo: localStorage.getItem('no'),
          second,
          type: Array.from(set)[0],
        })
        .then((res) => {
          console.log('res:', res)
          if (res.errcode === 0) {
            this.$toast.success({
              message: this.type === 'add' ? '新建成功' : '修改成功',
              // mask: true
            })
            setTimeout(() => {
              this.$router.back()
            }, 2000)
          } else {
            this.canSubmit = true
            this.$toast.fail(res.errmsg)
          }
        })
        .catch((err) => {
          this.canSubmit = true
          this.$toast.fail({
            message: this.type === 'add' ? '新建失败' : '修改失败',
            // mask: true
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.edit {
  min-height: calc(100% - 60px - 40px);
  background: #ffffff;
  border-radius: 12px !important;
  overflow: hidden;
  margin: 15px 0;
  margin-bottom: 60px;
}

.footer {
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 30px);
  height: 72px;
  background: #ffffff;
  box-shadow: 0px 5px 5px rgba(208, 199, 255, 0.06);
  margin-left: -15px;
  margin-right: -15px;
  padding: 0 15px;

  span {
    // width: 120px;
    height: 42px;
    line-height: 42px;
    border: 1px solid #3865ff;
    border-radius: 5px;
    text-align: center;
    font-size: 16px;
  }

  .cancel {
    width: 120px;
    margin-right: 15px;

    color: #3865ff;
  }

  .add {
    flex: 1;
    background: #3865ff;
    color: #ffffff;
    border-radius: 5px;
  }
}

.fm-list {
  padding: 0 0.3rem;

  .title {
    height: 21px;
    font-size: 15px;
    font-weight: bold;
    color: #14284a;
    margin-bottom: 10px;
  }

  .title2 {
    margin-top: 20px !important;
  }

  .check-item {
    height: 30px;
  }
}

.van-cell {
  padding: 17px 15px !important;

  /deep/ .van-cell__title {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    color: #14284a;
  }

  /deep/ .van-cell__value {
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }

  /deep/ .van-field__body {
    width: 100%;

    input {
      width: 100%;
    }
  }
}
</style>
